<template>
  <div style="padding: 20px">
    <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
      <div></div>
      <a-button type="primary" @click="addSellPlan">
        {{ $t('ADD') || '添加' }}
      </a-button>
    </div>
    <a-table row-key="id" :data-source="table.data">
      <a-table-column title="标题" data-index="title"/>
      <a-table-column title="副标题" data-index="subTitle"/>
      <a-table-column title="封面图片">
        <template slot-scope="text,record">
          <img
            style="width: 50px; height: auto"
            :src="record.coverPath"
            :preview-src-list="[record.coverPath]"/>
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="text, record">
          <a-button type="link" @click="editSellPlan(record.id)">{{ $t('EDIT') || '编辑' }}
          </a-button>
          <a-divider type="vertical"/>
          <a-button type="link" @click="editSellPlanGoods(record.id)">商品
          </a-button>
          <a-divider type="vertical"/>
          <a-button type="link" @click="deleteSellPlan(record.id)">{{ $t('DELETE') || '删除' }}
          </a-button>
        </template>
      </a-table-column>
    </a-table>
    <a-modal
:footer="null"
      title="预售计划编辑"
      append-to-body
      v-model="form.visible">
      <sellPlan-edit
        v-if="form.visible"
        :day="day"
        :sell-plan-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </sellPlan-edit>
    </a-modal>
    <a-drawer
      append-to-body
      title="预售商品"
      v-model="skuForm.visible"
    >
      <sell-plan-goods-list
        v-if="skuForm.visible"
      :sell-plan-id="skuForm.data.id"
      :on-cancel-handler="closeForm"
      :on-submit-handler="closeForm"
      >
      </sell-plan-goods-list>
    </a-drawer>
  </div>
</template>

<script>
import moment from 'moment';
import {
  _querySellPlans,
  _deleteSellPlan,
} from '@/api/sellPlanApi';
import SellPlanEdit from './SellPlanEdit.vue';
import SellPlanGoodsList from './SellPlanGoodsList.vue';

async function getSellPlansList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _querySellPlans({
    startAt: `${this.day} 00:00:00`,
    endAt: `${this.day} 23:59:59`,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
}

function editSku(sellPlanId) {
  this.skuForm.data.id = sellPlanId;
  this.skuForm.visible = true;
  // this.$router.push(`/sellPlan/${sellPlanId}/sku`);
}

function addSellPlan() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editSellPlan(sellPlanId) {
  this.form.data.id = sellPlanId;
  this.form.data.day = this.day;
  this.form.visible = true;
}

function editSellPlanGoods(sellPlanId) {
  this.skuForm.data.id = sellPlanId;
  this.skuForm.visible = true;
  // this.$router.push(`/sell-plan/${sellPlanId}/goods`);
}

async function deleteSellPlan(sellPlanId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteSellPlan(sellPlanId);
      this.$message.success('删除成功');
      this.getSellPlansList();
    },
  });
}

// function showDailyPlan(day) {
//   // this.form.data.id = sellPlanId;
//   // this.form.visible = true;
//   // this.$router.push(`/sellPlan/${sellPlanId}`);
// }

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.skuForm.data.id = null;
  this.skuForm.visible = false;
  this.getSellPlansList();
}

async function deleteSellPlans(sellPlanId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteSellPlan(sellPlanId);
      this.$message.success('删除成功');
      this.getSellPlansList();
    },
  });
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getSellPlansList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getSellPlansList();
}

export default {
  name: 'SellPlanDailyView',
  components: {
    SellPlanGoodsList,
    SellPlanEdit,
  },
  props: {
    day: String,
  },
  watch: {
    day() {
      this.getSellPlansList();
    },
  },
  data() {
    return {
      category: {
        data: [],
      },
      series: {
        data: [],
      },
      brand: {
        data: [],
      },
      searchForm: {
        data: {
          year: moment()
            .format('YYYY'),
          name: '',
          categoryId: '',
          brandId: '',
          seriesId: '',
          memberOnly: '',
        },
      },
      calendar: {
        days: new Set(),
      },
      skuForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 20,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getSellPlansList,
    editSellPlanGoods,
    // showDailyPlan,
    deleteSellPlans,
    closeForm,
    editSku,
    handleSizeChange,
    handlePageChange,
    editSellPlan,
    deleteSellPlan,
    addSellPlan,
  },
  async created() {
    this.getSellPlansList();
  },
};
</script>

<style scoped>

</style>
